import { render, staticRenderFns } from "./black-vip-zone-section2.vue?vue&type=template&id=17a1526f&"
import script from "./black-vip-zone-section2.vue?vue&type=script&lang=js&"
export * from "./black-vip-zone-section2.vue?vue&type=script&lang=js&"
import style0 from "./black-vip-zone-section2.vue?vue&type=style&index=0&id=17a1526f&prod&lang=less&less=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports